<template>
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="34"
      height="34"
      rx="6"
      fill="#FFD9C3"
    />
    <path
      d="M22.3334 13.6667H11.6667C10.9303 13.6667 10.3334 14.2637 10.3334 15.0001V21.6667C10.3334 22.4031 10.9303 23.0001 11.6667 23.0001H22.3334C23.0698 23.0001 23.6667 22.4031 23.6667 21.6667V15.0001C23.6667 14.2637 23.0698 13.6667 22.3334 13.6667Z"
      stroke="#FF8A71"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.6667 23V12.3333C19.6667 11.9797 19.5262 11.6406 19.2762 11.3905C19.0261 11.1405 18.687 11 18.3334 11H15.6667C15.3131 11 14.9739 11.1405 14.7239 11.3905C14.4739 11.6406 14.3334 11.9797 14.3334 12.3333V23"
      stroke="#FF8A71"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
